import React from 'react';
import { ClientApiProps } from '../../common';
import { Button, DataGrid, DataGridColumn, DataGridExpandOptions, Header, downloadBlob } from 'acma-spa';
import { Acma_amateurradioassessment_statuscode, Acma_amateurradioassessmentmethods, IOperatorAssessment } from '../../api';
import { Link } from 'react-router-dom';

export interface AssessmentsProps extends ClientApiProps {
  rows: IOperatorAssessment[];
  onSpinner: (msg: string) => any;
  onAuthorisation: () => any;
}

const expandProps: DataGridExpandOptions<IOperatorAssessment> = {
  content: () => { },
  onChange: () => { },
  canExpand: () => false,
  rows: [],
};

const noWrapStyle: React.CSSProperties = { whiteSpace: 'nowrap' };

export const Assessments: React.FC<AssessmentsProps> = (props) => {
  const downloadCertificate = async (r: IOperatorAssessment) => {
    props.onSpinner('Downloading...');

    try {
      const url = `${props.baseUrl}/api/operator/certificate/${r.id}`;
      const defaultFileName = `${r.referenceNumber ?? 'certificate'}.pdf`;
      const mscalScopes = [`https://${props.b2cDomainName}.onmicrosoft.com/AcmaApis/Call`];
      const mimeType = 'application/pdf';

      await downloadBlob(url, props.msalClient, mscalScopes, defaultFileName, mimeType);
    } finally {
      props.onSpinner('');
    }
  };

  /**
   * Determines what certificate link to give to the user.
   */
  const GetCertificateLink = (assessment: IOperatorAssessment) => {
    switch (assessment.assessmentMethod) {
      case Acma_amateurradioassessmentmethods.DataMigration:
        return 'Issued';
      case Acma_amateurradioassessmentmethods.PreviousQualification:
        return <span style={noWrapStyle}>{Acma_amateurradioassessment_statuscode.Reported}</span>;
      default:
        switch (assessment.status) {
          case Acma_amateurradioassessment_statuscode.Approved:
            return (
              <Link to={`/forms/amateurradio/certificate/${assessment.id}`} style={noWrapStyle}>
                Apply for Certificate of Recognition
              </Link>
            );

          case Acma_amateurradioassessment_statuscode.Requested:
            return <span style={noWrapStyle}>Certificate Application Submitted</span>;

          case Acma_amateurradioassessment_statuscode.Issued:
            return (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadCertificate(assessment);
                }}
                style={noWrapStyle}>
                Download
              </a>
            );

          default:
            return <span style={noWrapStyle}>{assessment.status}</span>;
        }
    }
  };

  const columnsProps: DataGridColumn<IOperatorAssessment>[] = [
    { label: 'Level', value: (x) => x.type },
    { label: 'Number', value: (x) => x.referenceNumber },
    { label: 'Received On', value: (x) => (x.assessmentMethod !== Acma_amateurradioassessmentmethods.DataMigration ? x.createdOn?.toLocaleDateString() : '') },
    { label: '', value: (x) => GetCertificateLink(x), width: '10' },
  ];

  return (
    <>
      <Header label="Completed examinations">
        <Button label="Locate completed exams" id="locate-exams" onClick={() => props.onAuthorisation()} />
      </Header>
      <DataGrid<IOperatorAssessment> expand={expandProps} columns={columnsProps} rows={props.rows} noRowsMessage="No qualifications found." />
    </>
  );
};
